import * as d3 from 'd3';

export const calculateScaleTime: (range: Array<Date>) => number = (range) => {
  const maxYears = 3;
  const maxMonths = 12;
  const maxWeeks = 1;

  if (d3.utcYear.count(range[0], range[1]) > maxYears) {
    // we want years
    return d3.utcYear.count(range[0], range[1]);
  } else if (d3.utcMonth.count(range[0], range[1]) > maxMonths) {
    // we want months
    return d3.utcMonth.count(range[0], range[1]);
  } else if (d3.utcWeek.count(range[0], range[1]) > maxWeeks) {
    // we want weeks
    return d3.utcWeek.count(range[0], range[1]);
  } else if (d3.utcDay.count(range[0], range[1])) {
    // we want days
    return d3.utcDay.count(range[0], range[1]);
  }

  return 0;
};

export const bubbleScale: (dateRange: Array<number>, value: number, circleSizes: Array<number>) => number = (
  dateRange,
  value,
  circleSizes
) => {
  //  we want Range-Grading radius so we use quantile Scale
  // that gives us one of the values defined in the range

  const scaleQuantile = d3.scaleQuantile().domain(dateRange).range(circleSizes);

  return scaleQuantile(value);
};

export const growthColorScale: (dataRange: Array<number>, value, colors: Array<string>) => string = (dataRange, value, colors) => {
  /*

    we want Range-Grading radius so we use quantile Scale
    that gives us one of the values defined in the range
    we want to map 4 sequential colors to a degrees where:

   -> 270 and 280 are fixed values we don't want arrows going up in red!

      1. Red under 280 degrees
      2. Violet between 270 and 280
      3. blue between from 270 to half way to the minimum value (if exists)
      4. green from minimum value (if exists) to half way to 270
   */

  const scaleQuantile = d3.scaleQuantile().domain([dataRange[0], 270, 280, dataRange[1]]).range(colors);

  return scaleQuantile(value);
};

/**
 * This function clears the time and sets it to 0
 * and then return the date with time set to 0.
 *
 * @param timestamp - timestamp to change.
 */
export const clearTimeAndReturnDate = (timestamp: number): Date =>
  new Date(`${new Date(timestamp).toISOString().split('T')[0]}T00:00:00.000`);
